import { api, getConvexClient, BUSINESS_ID } from "@/lib/convex";

const AD_REF_STORAGE_KEY = "dcw_ad_ref";
const GCLID_STORAGE_KEY = "dcw_gclid";

/**
 * Registrerer et annonseklikk, og husker det til bestillingen skjer.
 *
 * Skrev tidligere til 5 Stars' gamle Supabase-prosjekt, som er lagt ned. Det
 * betydde at hvert eneste annonseklikk gikk tapt, og konverteringsraten i
 * Ascendly regnet bestillinger mot null klikk. Klikkene gaar til Convex naa,
 * samme sted som bestillingene.
 *
 * To kilder, fordi de to annonsenettverkene oppfoerer seg ulikt:
 *  - Facebook og Instagram sender folk til lenken vi selv lager, med ?ref=
 *  - Google Ads auto-tagger i stedet med gclid, og baerer aldri vaar ref
 *
 * Uten gclid ville hvert Google-klikk sett ut som direktetrafikk.
 */
export async function trackAdClickFromUrl() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref") ?? undefined;
  const gclid = params.get("gclid") ?? undefined;
  if (!ref && !gclid) return;

  try {
    if (ref) localStorage.setItem(AD_REF_STORAGE_KEY, ref);
    if (gclid) localStorage.setItem(GCLID_STORAGE_KEY, gclid);
    await getConvexClient().mutation(api.annonser.registrerKlikk, {
      businessId: BUSINESS_ID,
      adRef: ref,
      gclid,
    });
  } catch (err) {
    // Et tapt klikk skal aldri stoppe siden i aa laste.
    console.error("[annonsesporing] feilet", err);
  }
}

/** Annonsen som brakte besoekende hit, for aa tilskrive bestillingen. */
export function getStoredAdRef(): string | undefined {
  if (typeof window === "undefined") return undefined;
  // Kom de fra Google Ads uten egen ref, tilskrives bestillingen Google.
  return (
    localStorage.getItem(AD_REF_STORAGE_KEY) ??
    (localStorage.getItem(GCLID_STORAGE_KEY) ? "google-ads" : undefined) ??
    undefined
  );
}
